module.exports = __webpack_public_path__ + "static/img/authorize.a9ee96c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/authorize.png
// module id = 9Rh2
// module chunks = 1